import { Component, OnInit } from '@angular/core';
import { ProductsService } from 'src/app/services/products.service';
import { BasketsService } from 'src/app/services/baskets.service';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DialogVideoComponent } from '../dialogs/dialog-video/dialog-video.component';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit {

  public baskets;
  public products;
  public dressings;

  public basketHeight;
  public productsHeight;
  public dressingHeight;

  constructor(private productsService: ProductsService, private basketsService: BasketsService, private dialog: MatDialog, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.basketsService.getBaskets().subscribe(data => {
      this.baskets = data.data;

      let lengths: any = [];

      this.baskets.map(basket => {
        lengths.push(basket.description.length);
      });
      this.basketHeight = (Math.max(...lengths) - 5) + 'px';
    })

    this.productsService.getLeaves().subscribe(data => {
      this.products = data.data;

      let lengths: any = [];

      this.products.map(product => {
        lengths.push(product.description.length);
      });
      this.productsHeight = (Math.max(...lengths) - 25) + 'px';
    });

    this.productsService.getDressings().subscribe(data => {
      this.dressings = data.data;
      let lengths: any = [];

      this.dressings.map(dressing => {
        lengths.push(dressing.description.length);
      });
      this.dressingHeight = (Math.max(...lengths) + 25) + 'px';
    });
  }

  onWatchVideo() {
    this.dialog.open(DialogVideoComponent, {
      maxHeight: '90vh',
      maxWidth: '1000px'
    });
  }
}
